import { type ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import './Screen.scss';
import { NavLinkProp } from '../../types.ts';
// @ts-expect-error TS2307: Cannot find module probably because it's out of src directory.
import version from '../../../../VERSION';

interface ScreenProps {
  navigationLinks?: NavLinkProp[];
  extraNavContent?: ReactNode;
}

const Screen = ({ navigationLinks, extraNavContent }: ScreenProps) => {
  const localPortal = () => {
    const port = window.location.port;

    switch (port) {
      case '8084':
        return 'Consumer Portal';
      case '8081':
        return 'Admin Portal';
      case '8083':
        return 'Dealer Portal';
    }
  };

  const portal = () => {
    const url = window.location.href;
    const isDealerPortal =
      url.includes('power-dealer.aquafinance') ||
      url.includes('pwr-dlr-stage.aquafinance') ||
      url.includes('8083') ||
      url.includes('pwr-dealer');
    const isConsumerPortal =
      url.includes('power.aquafinance') ||
      url.includes('pwr-stage.aquafinance') ||
      url.includes('8084') ||
      url.includes('pwr-consumer');

    if (isDealerPortal) {
      return 'dealer';
    }
    if (isConsumerPortal) {
      return 'consumer';
    }
    return;
  };

  return (
    <>
      <div className="screen-mode">
        {import.meta.env.MODE === 'development' && (
          <>
            <span>Development Mode</span>
            <span>{localPortal()}</span>
          </>
        )}
        {import.meta.env.MODE !== 'PRODUCTION' && import.meta.env.MODE !== 'test' && (
          <span>{`Version ${version}`}</span>
        )}
      </div>
      <Header navigationLinks={navigationLinks} portal={portal()} extraNavContent={extraNavContent} />
      <div className="Screen">
        <Outlet />
      </div>
      <Footer />
    </>
  );
};

export default Screen;
